import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { FormCondutorComponent } from './form-condutor/form-condutor.component';
import { ListCondutorComponent } from './condutor.component';
import { AnotacaoComponent } from './anotacao/anotacao.component';
import { AnotacaoService } from './anotacao/anotacao.service';
import { CondutorService } from './condutor.service';
import { FormAnotacaoComponent } from './anotacao/form-anotacao/form-anotacao.component';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY', // Formato para parsing (entrada)
  },
  display: {
    dateInput: 'DD/MM/YYYY', // Formato para exibição
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
    declarations: [
        FormCondutorComponent,
        ListCondutorComponent,
        FormAnotacaoComponent,
        AnotacaoComponent,
    ],
    imports: [
        SharedModule,
        MatMomentDateModule,
    ],
    providers: [
        CondutorService,
        AnotacaoService,
        { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
    ],
    exports: [
      FormCondutorComponent,
      ListCondutorComponent,
      FormAnotacaoComponent,
      AnotacaoComponent,
    ]
})
export class CondutorModule { }
